import { mountApplications } from '~/wikis/show';

mountApplications();
